const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3, // Each child will animate 0.3s after the previous one
    },
  },
};

const checkpointVariants = {
  hidden: { opacity: 0, y: 20, scale: 0.8 }, // Start 20px down, smaller, and invisible
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1, 
    transition: { type: 'spring', stiffness: 100, damping: 10 }
  },
};

export { containerVariants, checkpointVariants };